import { acquireToken } from './msal';

export async function authHeaders(): Promise<Record<string, string>> {
  const token = await acquireToken().catch(() => null);
  return token ? { Authorization: `Bearer ${token}` } : {};
}
